import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Row, Col, Form } from 'reactstrap';
import { NavLink as Link } from 'redux-first-router-link';

import { MDTButton, MDTInput } from 'mdt-core-components';
import { MDTCheckbox } from 'mdt-core-components';
import { MDTApp } from 'mdt-core-components/src/actions/bootAction.js';
import { sendEventTrackingData } from 'mdt-core-components/src/helpers/commonUtils.js';
import './login.css';

export class UserLogin extends Component {
  constructor(props) {
    super(props);
    this.emailAddress = this.emailAddress.bind(this);
    this.passwordChange = this.passwordChange.bind(this);
    this.submitLoginInfo = this.submitLoginInfo.bind(this);
    this.validateForm = this.validateForm.bind(this);

    this.emailRef = React.createRef();
    this.passwordRef = React.createRef();
    this.collectDataRef = React.createRef();

    this.state = {
      isAllowCollectData: false,
      username: '',
      usernameValidate: false,
      password: '',
      passwordValidate: false,
      formValidation: false,
      collectDataValidate : true,
      internelUserError: false,
      requestAccessEnabled: MDTApp.getSetting('features.requestAccessEnabled'),
      registerMessageEnabled: MDTApp.getSetting(
        'features.registerMessageEnabled'
      ),
      showRegisterMessage: MDTApp.getSetting(
        'features.registerMessageEnabled'
      )
    };
    this.trackingObj = {
      accManagement: 'accManagement',
    };
  }

  componentDidMount() {
    this.validateForm();
  }
  emailAddress(value, valid) {
    this.setState({ username: value }, function() {
      const email = value.trim();

      this.checkToShowRegisterMessage(email);
    });
  }
  onEmailBlur(t, e, valid) {
    let msg = t('useMedtronicNetworkIdError');
    const email = e.target.value.trim();
    const medtronicEmailValidation = new RegExp('@medtronic.coms*', 'i');
    const loginOptions = this.props.loginOptions;
    if (medtronicEmailValidation.test(email)) {
      this.setState({ internelUserError: true, formValidation: false });
      loginOptions.medtronicEmailValidation(true, msg);
    } else {
      //_.includes(email, '@') && emailValidation.test(email) &&
      loginOptions.medtronicEmailValidation(false, (msg = ''));
      this.setState(
        { username: e.target.value.trim(), usernameValidate: valid },
        function() {
          this.validateForm();
        }
      );
    }

    this.checkToShowRegisterMessage(email);
  }

  //check if the inserted value contains "@", if not, hide the RegisterMessage and related checkBox.
  checkToShowRegisterMessage = (email) => {
    const { registerMessageEnabled } = this.state;
    if (!email.includes("@") && !_.isEmpty(email) && registerMessageEnabled) {
      this.setState({ showRegisterMessage: false })
    } else if((email.includes("@") || _.isEmpty(email)) && registerMessageEnabled) {
      this.setState({ showRegisterMessage: true })
    }
  }

  onPasswordBlur(e, valid) {
    const password = e.target.value.trim();
    !this.state.internelUserError &&
      this.setState({ password, passwordValidate: valid }, function() {
        this.validateForm();
      });
  }
  passwordChange(value, valid) {
    this.setState({ password: value }, function() {
      this.setState({ formValidation: !!value });

      if(this.state.registerMessageEnabled) {
        this.setState({ passwordValidate:valid });
        this.validateForm();
      }
    });
  }

  downloadFile(){
    var aEle = document.createElement("a");
    let filename = window.t('login.downloadfilename');
    aEle.download = filename+".pdf";
    aEle.href = '/bu/sales_collection_notification.pdf';
    aEle.click();
  }

  onCheckboxChange(checked) {
    let _this = this;
    this.setState({ isAllowCollectData: checked },function () {
      _this.setState({
        collectDataValidate: _this.collectDataValid()
      }, function(){
        _this.validateForm();
      })
    });
  }

  // checks if form has data available
  setFormData(){
    const { registerMessageEnabled, showRegisterMessage } = this.state;
    let _this = this;
    let emailCurr = this.emailRef.current;
    let passwordCurr = this.passwordRef.current;

    const username = emailCurr.state.value;
    const password = passwordCurr.state.value;

    let updated_state = {
      username: username,
      usernameValidate: emailCurr.fieldValidate(username),
      password: password,
      passwordValidate: passwordCurr.fieldValidate(password),
    }

    if (registerMessageEnabled && showRegisterMessage){
      let collectDataCheckCurr = this.collectDataRef.current;
      const collectDataAllowed  = collectDataCheckCurr.state.checked;
      updated_state = { ...updated_state,
        isAllowCollectData: collectDataAllowed,
        collectDataValidate: _this.collectDataValid()
      }

    }
    let promise = new Promise(function(myResolve, myReject) {

      try{
        _this.setState(
          updated_state,
          function(){
            _this.validateForm(
              function(){
                myResolve();
              }
            );
          }
        )
      }
      catch (e){
        myReject(e);
      }

    });

    return promise;
  }

  collectDataValid(){
    let is_valid = false;

    if (!this.state.registerMessageEnabled){
        is_valid = true;
    }
    else{
      if (this.state.isAllowCollectData){
        is_valid = true;
      }
      else{
        is_valid = false;
      }
    }

    return is_valid
  }

  validateForm(cb) {

    let validation = false;
    //if(/\S+/.test(this.state.passwordValidate) && /\S+/.test(this.state.passwordValidate)){
    if (this.state.usernameValidate && this.state.passwordValidate) {
      validation = true;
    }
    if (!this.collectDataValid() && this.state.showRegisterMessage) {
      validation = false;
    }

    this.setState({ formValidation: validation },
      function(){
        if (cb){
          cb();
        }
      });
  }

  submitLoginInfo(e) {
    e.preventDefault();
    let _this = this;
    let _window = window;

    // set form data when form submitted
    // When autofill is enables on browser
    // will pick the latest data
    this.setFormData().then(
      function(){
        const { formValidation, username, password, isAllowCollectData } = _this.state;
        const { loginOptions } = _this.props;
        if (formValidation) {
          const param = {
            username,
            password,
            grant_type: 'password',
            scope: 'openid profile groups apps bus offline_access',
            acr_values: 'tenant:MDT',
            client_id: 'mdtcJs',
            client_secret: 'medtronic',
          };
          if (loginOptions.submitLoginInfo) loginOptions.submitLoginInfo(param);
        }
        else{
          _this.emailRef.current.fieldValidate(username);
          _this.passwordRef.current.fieldValidate(password);

          if (_this.state.registerMessageEnabled && _this.state.showRegisterMessage){
            _this.collectDataRef.current.fieldValidate(isAllowCollectData);
          }
        }
      }
    ).catch((e) => {
        console.log('Unexpected error in setFormData');
        console.error(e);
        throw e;
    });
  }

  trackOnClick = eventAction => {
    const { accManagement } = this.trackingObj;
    const eventParamObj = {
      eventCategory: accManagement,
      eventAction,
      eventLabel: 'initiated',
    };
    sendEventTrackingData(eventParamObj);
  };

  render() {
    const { registerMessageEnabled, showRegisterMessage } = this.state;
    const { t } = this.props;
    const { requestAccessEnabled } = this.state;
    const emailprops = {
      disabled: false,
      name: 'email',
      type: 'text',
      errorMessage: t('requiredError'),
      validate: false,
      required: true,
      className: 'body2 m-emphasis',
      onChange: (value, valid) => this.emailAddress(value, valid),
      onBlur: (e, valid) => this.onEmailBlur(t, e, valid),
    };
    const passwordprops = {
      disabled: false,
      type: 'password',
      errorMessage: t('requiredError'),
      validate: false,
      required: true,
      className: 'body2 m-emphasis',
      onChange: (value, valid) => this.passwordChange(value, valid),
      onBlur: (e, valid) => this.onPasswordBlur(e, valid),
    };
    const checkboxProps = {
      checked: this.state.isAllowCollectData,
      onChange: checked => this.onCheckboxChange(checked),
      className: 'mdt-checkbox',
      errorClassName: 'checkbox-invalid',
      required: true
    };
    return (
      <Form onSubmit={this.submitLoginInfo}>
        <Row className="login-form">
          <Col xs={12} className="mdt-input" data-test="login-email">
            <div className="label-margin">
              <span className="body2">{t('enterEmailId')}</span>&nbsp;
              <span className="body2 m-emphasis">{t('mdtEmployees')}</span>
            </div>
            <MDTInput ref={this.emailRef} {...emailprops} />
          </Col>

          <Col xs={12} className="mdt-input" data-test="login-password">
            <div className="label-margin">
              <span className="body2 ">{t('password')}</span>
            </div>
            <MDTInput ref={this.passwordRef} {...passwordprops} />
          </Col>
          <Col xs={12} className="text-right mt-3 forgot-password-text">
            <Link
              onClick={() => this.trackOnClick('forgotPwd')}
              to={{ type: 'FORGOTPASSWORD' }}
              className="body2 link"
            >
              {t('forgotPassword')}
            </Link>
          </Col>
          {showRegisterMessage && (
          <Col
            xs={{ size: 10, offset: 1 }}
            className="submit-sec"
            data-test="login-button"
          >
            <Row className='login-allow-checkbox'>
             <MDTCheckbox ref={this.collectDataRef}
            {...checkboxProps}
          />
          <Link
              onClick={() => this.downloadFile()}
              className={ checkboxProps.required && !this.state.collectDataValidate ? "body2 link link-text checkbox-invalid": "body2 link link-text" }
              to='javascript:void(0)'
            >
              {t('login.allowSalesDataCollection')}
            </Link></Row>

            <MDTButton
              {...{
                type: 'submit',
                name: 'mdt-button',
                label: t('signIn'),
                className: 'secondary',
              }}
            />
          </Col>)}
          {!showRegisterMessage && (
          <Col
            xs={{ size: 10, offset: 1 }}
            className="submit-sec"
            data-test="login-button"
          >
            <MDTButton
              {...{
                type: 'submit',
                name: 'mdt-button',
                label: t('signIn'),
                className: 'secondary',
              }}
            />
          </Col>)}

          <Col xs={1}></Col>
          {requestAccessEnabled && (
            <Col xs={{ size: 10, offset: 1 }}>
              <div className="request-access">
                <Link
                  onClick={() => this.trackOnClick('requestAccess')}
                  to={{type: 'REQUESTACCESS' }}
                  className="body2 link"
                >
                  {t('requestAccessMessage')}
                </Link>
              </div>
            </Col>
          )}
          <Col xs={1}></Col>
        </Row>
      </Form>
    );
  }
}

export default withTranslation()(UserLogin);
